import { FC, SVGProps } from "react";

export const DefaultCampaignLogo: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.4667 21.0667C15.3266 21.5745 15.0879 22.0497 14.7641 22.4652C14.4404 22.8807 14.038 23.2284 13.5799 23.4884C13.1218 23.7484 12.617 23.9156 12.0942 23.9806C11.5715 24.0455 11.0411 24.0068 10.5333 23.8667C10.0256 23.7266 9.55034 23.4879 9.13482 23.1642C8.7193 22.8404 8.37161 22.438 8.11161 21.9799C7.8516 21.5218 7.68437 21.017 7.61947 20.4943C7.55457 19.9715 7.59326 19.4411 7.73333 18.9334M4 13.3334L28 6.66669V22.6667L4 17.3334V13.3334Z"
      stroke="#763FF9"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
